import { Button, Grid } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { styled } from '@material-ui/styles';
import { ShowArchiveFilter, DateFilter, TypeFilter } from 'components/Events';

const StyledGridForButton = styled(Grid)({
  padding: '10px 0px 10px 0px',
});

const EventsFilterDesktop = ({ submitFilter, restoreDefaultFilters }) => {
  const { t } = useTranslation();
  return (
    <Grid container direction="row" justifyContent="space-evenly" spacing={4}>
      <Grid container item sm={12} spacing={4} justifyContent="flex-start">
        <Grid item sm={12}>
          <ShowArchiveFilter />
        </Grid>
        <Grid item sm={12}>
          <TypeFilter submitFilter={submitFilter} />
        </Grid>

        <Grid item sm={12}>
          <DateFilter submitFilter={submitFilter} />
        </Grid>
      </Grid>
      <Grid container item sm={12} justifyContent="space-evenly">
        <StyledGridForButton item>
          <Button
            onClick={() => {
              restoreDefaultFilters();
            }}
            color="primary"
            variant="contained"
            sx={{ flex: 1 }}
          >
            {t('clear')}
          </Button>
        </StyledGridForButton>
      </Grid>
    </Grid>
  );
};

EventsFilterDesktop.propTypes = {
  submitFilter: PropTypes.func.isRequired,
  restoreDefaultFilters: PropTypes.func.isRequired,
  filteredData: PropTypes.object,
};

EventsFilterDesktop.defaultProps = {
  filteredData: {},
};

export default EventsFilterDesktop;
